import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/3_red/3_red"
 * Contains 1 texture(s)
 */
export class Mobile3RedAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/3_red/3_red';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '3_red.png'
    ] as const;
}
